import i18next from 'i18next';

i18next.addResources('es_CL', 'BlockTable', {
  title: 'Productos y Modificadores bloqueados',
  search: 'Buscar...',
  result: '{{total}} Resultado de tu búsqueda',
  results: '{{total}} Resultados de tu búsqueda',
  noResults: 'No encontramos resultados para “{{term}}”',
  clearSearch: 'Limpiar búsqueda',
  term: '“{{term}}”'
});

i18next.addResources('es_CR', 'BlockTable', {
  title: 'Productos y Modificadores bloqueados',
  search: 'Buscar...',
  result: '{{total}} Resultado de tu búsqueda',
  results: '{{total}} Resultados de tu búsqueda',
  noResults: 'No encontramos resultados para “{{term}}”',
  clearSearch: 'Limpiar búsqueda',
  term: '“{{term}}”'
});
